module.exports = __webpack_public_path__ + "media/קה.f78d43c6.mp3";